<template>
  <v-list
    dense
    nav
  >
    <v-list-item
      v-for="item in pages"
      :key="item.title"
      :to="item.link"
    >
      {{ item.title }}
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  props: {
    pages: Array,
  },
};
</script>

<style scoped>

</style>
